import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './DietplanMom.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import DietPlanSlider from '../common/DietPlanSlider';
import DietPlanArticle from '../common/DietPlanArticle';
import withContext from "../../../withContext";

const service = new Service();

class DietplanMom extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let stageResponse = [];
        let articlesData = [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            if (window.__initialData__['initialData']['stageResponse']) {
                stageResponse = window.__initialData__['initialData']['stageResponse'];
            }
            if (window.__initialData__['initialData']['result']) {
                articlesData = window.__initialData__['initialData']['result'];
            }
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
                if (props.staticContext.initialData['initialData']['stageResponse']) {
                    stageResponse = props.staticContext.initialData['initialData']['stageResponse'];
                }
                if (props.staticContext.initialData['initialData']['result']) {
                    articlesData = props.staticContext.initialData['initialData']['result'];
                }
            }
        }
        this.state = {
            initialData: initialData,
            currentStageId: '',
            stageResponse: stageResponse,
            articlesData: articlesData,
            currentstage: '',
            myactiveStage: '',
            shareurl: '',
            cardList: '',
            count:1,
            cardListmonth: '',
            cardsTotalHeight: '',
            ClickId:''
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        let childinfo = childData['UserChildList'];
        let postdietarr = [];
        let pageData;

        if (childinfo) {
            postdietarr = childData['UserChildList'];
        } else {
            postdietarr = [];
        }
        if (postdietarr.length > 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [{
                    "childid": postdietarr[1]['ChildId'],
                    "childname": postdietarr[1]['ChildName'],
                    "dob": postdietarr[1]['DOB'],
                    "childgender": postdietarr[1]['Gender'],
                    "childphoto": postdietarr[1]['childPhoto']
                }];

            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        else if (postdietarr.length == 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        if (childinfo) {
            childinfo = [{ "childinfo": childinfo }];
        } else {
            childinfo = [{ "pageNo": 1, "pageSize": 10 }];
        }
        pageData = [{
            "childinfo": childinfo,
            "pageNo": 1,
            "pageSize": 10,
            "stageid": ""
        }];
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "momdiet/getdietplan";
        let body = JSON.stringify({ pageData });
        console.log('body >>>>>>>', body)
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {

        document.addEventListener("click", actions.domClick);
        if (window.innerWidth > 767) {
            this.CardScroll = this.CardScroll.bind(this);
            document.querySelector(".card_container").addEventListener("scroll", this.CardScroll, false);
        } else {
            this.CardScroll = this.CardScroll.bind(this);
            window.addEventListener("scroll", this.CardScroll, false);
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.getDietplanMomData();
            } else {
                localStorage.setItem('DietplanMomData', JSON.stringify(this.state.initialData));
                this.landdingPage();
            }
        } else {
            if (localStorage.getItem('DietplanMomData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('DietplanMomData')),
                    stageResponse: JSON.parse(localStorage.getItem('DietplanMomData'))['stageResponse'] ? JSON.parse(localStorage.getItem('DietplanMomData'))['stageResponse'] : [],
                    articlesData: JSON.parse(localStorage.getItem('DietplanMomData'))['result']
                });
                this.landdingPage();
            }
            service.hideLoader();
        }
    }

    getDietplanMomData() {
        var postData = {};
        let childinfo = global.userAry['childData']['UserChildList'];
        let postdietarr = [];

        if (global.userAry['childData'] && global.userAry['childData']['UserChildList']) {
            postdietarr = global.userAry['childData']['UserChildList'];
        } else {
            postdietarr = [];
        }
        if (postdietarr.length > 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [{
                    "childid": postdietarr[1]['ChildId'],
                    "childname": postdietarr[1]['ChildName'],
                    "dob": postdietarr[1]['DOB'],
                    "childgender": postdietarr[1]['Gender'],
                    "childphoto": postdietarr[1]['childPhoto']
                }];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        else if (postdietarr.length == 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        if (childinfo) {
            childinfo = [{ "childinfo": childinfo }];
        } else {
            childinfo = [{ "pageNo": 1, "pageSize": 10 }];
        }
        postData = [{
            "childinfo": childinfo,
            "pageNo": 1,
            "pageSize": 10,
            "stageid": ""
        }];
        var url = global.api_ci_url + "DietplanMom/getDietplanMomData";
        service.postServiceCall(url, postData).then((json) => {
            console.log("json==============>",json);
            if (json['result']) {
                this.setState({
                    initialData: json,
                    stageResponse: json['stageResponse'] ? json['stageResponse'] : [],
                    articlesData: json['result']
                }, () => { this.landdingPage(); });
                localStorage.setItem('DietplanMomData', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    landdingPage() {
        if (global.ftk != '') {
            if (this.state.initialData) {
                this.setState({
                    currentStageId: this.state.initialData['currentStageId']
                });
            }
        } else {
            this.setState({ currentStageId: 0 });
        }
        setTimeout(() => {
            this.state.currentstage = 1;
            this.state.cardList = document.querySelectorAll('.tablink');
            this.state.cardListmonth = document.querySelectorAll('.month-old');
            if (window.innerWidth > 767) {
                let cheight = document.querySelector('#month-card-14') ? document.querySelector('#month-card-14').offsetHeight : 0;
                document.querySelector('.card_container').style.height = cheight + 'px';
            }

            if (parseInt(this.state.currentStageId) > 0) {
                this.state.currentstage = this.state.currentStageId;
            }
            let id = this.state.currentstage;
            document.querySelector('.month-slider').scrollLeft = 0;
            let monthSliderPosition = actions.calScrollLeft(id,9);

            let left = parseInt(id) + 5;
            let rightd = parseInt(id) - 1;
            let cards_offset = 0;
            if (document.querySelector('#month-card-' + left) && document.querySelector('#month-card-' + left).offsetTop) {
                cards_offset = document.querySelector('#month-card-' + left).offsetTop;
                // cards_offset = document.querySelector('#month-card-' + left).getBoundingClientRect().top + window.scrollY
            }
            this.state.cardsTotalHeight = 0;
            if (window.innerWidth < 767) {
                for (let m = 6; m < left; m++) {
                    this.state.cardsTotalHeight += document.querySelector('#month-card-' + m).offsetHeight;
                }
            } else {
                for (let m = 6; m < left; m++) {
                    this.state.cardsTotalHeight += document.querySelector('#month-card-' + m).offsetHeight + 17;
                }

            }

            let horiztallength;
            document.querySelector('.act' + (this.state.currentstage - 1)) && document.querySelector('.act' + (this.state.currentstage - 1)).classList.add('active');

            actions.changeTabTextColor(this);
            if ((window).innerWidth < 767) {
                document.querySelector('.month-slider').scrollLeft = (monthSliderPosition - 15);
                horiztallength = cards_offset - 260;

                if (id == 1) {
                    document.querySelector('html,body').scrollTop = 0
                } else {
                    setTimeout(() => {
                        document.querySelector('html,body').scrollTop = (cards_offset-50)
                    }, 1000);
                }
            } else {
                document.querySelector('.month-slider').scrollLeft = (monthSliderPosition);
                horiztallength = (rightd * cards_offset);
                if (this.state.currentstage == "1") {
                    document.querySelector('.card_container').scrollTop = (0)
                } else {
                    document.querySelector('.card_container').scrollTop = this.state.cardsTotalHeight
                }
            }
        }, 100);
        if (window.innerWidth < 768) {
            actions.removeSelfClass('M24_pink', 'M15_fc88af');
            actions.removeSelfClass('B20_42', 'M15_42');
            actions.removeSelfClass('M14_42', 'M13_42');
            actions.removeSelfClass('R14_9e', 'R11_9e');
            actions.removeSelfClass('R16_42', 'R14_42');
        }
    }
// export function isInViewport(el,tool) {
//     // console.log("element===============>",el);
//     const scroll = window.scrollY || window.pageYOffset
//     const boundsTop = el.getBoundingClientRect().top + scroll
//     const viewport = {
//         top: scroll,
//         bottom: scroll + window.innerHeight,
//     }
//     const bounds = {
//         top: boundsTop,
//         bottom: boundsTop + el.clientHeight,
//     }
//     if(window.innerWidth < 767 && tool=="PD"){
//         return el.getBoundingClientRect().top >= 0 && el.getBoundingClientRect().bottom <= window.innerHeight
//     }else{
//         return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
//         || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
//     }
// }
    CardScroll() {
        let id;
        for (let i = 6; i <= 14; i++) {
            let flag = actions.isInViewport(document.querySelector("#month-card-" + i));
            if (flag) {
                var recdMonthId = document.querySelector('#month-card-' + i).id;
                var monthId = recdMonthId.slice("11");
                var mnth = parseInt(monthId) - 5;
                for (let i = 0; i < this.state.cardList.length; i++) {
                    if (document.querySelector('.act' + i).classList.contains('active')) {
                        document.querySelector('.act' + (i)).classList.remove('active');
                    }
                }
                document.querySelector('.act' + (mnth - 1)).classList.add('active');
                actions.changeTabTextColor(this);
                if(window.innerWidth < 767 && this.state.ClickId==mnth){
                    break;
                }
                this.state.myactiveStage = document.querySelector('.act' + (mnth - 1)).offsetLeft;
                id = i - 5;
                document.querySelector('.month-slider').scrollLeft = 0;
                var monthSliderPosition = actions.calScrollLeft(id,9);
                if (window.innerWidth > 767) {
                    document.querySelector('.month-slider').scrollLeft = monthSliderPosition;
                }else{
                    document.querySelector('.month-slider').scrollLeft = monthSliderPosition - 15;
                }
            }
        }
        if (window.innerWidth < 767) {
            this.state.count=this.state.count+1;
            // console.log("window.scrollY========>",window.scrollY);
            let heightVal=document.querySelectorAll('.msite-ads-block')[0].offsetHeight + 
            document.querySelector('.mobile_header').offsetHeight;
            // console.log("heightVal========>",heightVal);
            if (window.scrollY > heightVal) {
                document.querySelector(".diet_top").classList.add("sticky_diet_top")
            } else {
                document.querySelector(".diet_top").classList.remove("sticky_diet_top")
            }
        }
    }
    shareOn(id) {
        console.log("share============>",id.target.nextSibling);
        let ary=document.querySelectorAll(".sharing-options");
        for(var i=0;i<ary.length;i++){
            ary[i].style.display = 'none';
        }
        if (window.innerWidth < 767) {
            id.target.nextSibling.style.display = 'block';
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
        id.target.nextSibling.style.display = 'block';
    }
    tablink(e, id) {
        console.log("tablink=======>",id);
        this.state.ClickId=id;
        for (let i = 0; i < this.state.cardList.length; i++) {
            if (document.querySelector('.act' + i).classList.contains('active')) {
                document.querySelector('.act' + (i)).classList.remove('active');
            }
        }
        console.log("tablink=======>1",document.querySelector('.act' + (id - 1)));
        document.querySelector('.act' + (id - 1)).classList.add('active');
        actions.changeTabTextColor(this);
        let left = parseInt(id) + 5;
        let rightd = parseInt(id) - 1;
        let cards_offset = 0;
        if (document.querySelector('#month-card-' + left) && document.querySelector('#month-card-' + left).offsetTop) {
            cards_offset = document.querySelector('#month-card-' + left).offsetTop;
        }
        this.state.cardsTotalHeight = actions.calScrollTop(left, id,17,this);

        let horiztallength;
        document.querySelector('.month-slider').scrollLeft = 0;
        let monthSliderPosition = actions.calScrollLeft(id,9);

        if ((window).innerWidth > 767) {
            document.querySelector('.month-slider').scrollLeft = monthSliderPosition;
            horiztallength = (rightd * cards_offset) - 300;
            if (id == 1) {
                document.querySelector(".card_container").scrollTop = 0;
            } else {
                document.querySelector(".card_container").scrollTop = this.state.cardsTotalHeight;
            }
            return !1
        } else {
            document.querySelector('.month-slider').scrollLeft = monthSliderPosition - 15;
            horiztallength = cards_offset - 260;
            document.querySelector("html,body").scrollTop = horiztallength + 210;
            return !1
        }

    }
    likeArticle(artiID, stageId, e, likecount, viewcnt, arttitle) {
        console.log("json===============>");
        let cls = e.target;
        if (global.ftk !== '') {
            service.showLoader();
            var postData = {
                "articleId": artiID,
                "actionStatus": "1",
                "moduleType": "momdietplan"
            }
            // var url = global.api_url + "breastfeeding/savefeedarticleslike";
            var url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekLike";
            service.postServiceCall(url, postData).then((json) => {
                // console.log("json===============>",json);
                service.hideLoader();
                console.log("json===============>",json);
                if (json['result'] == "success") {
                    cls.classList.add('active');
                    cls.nextSibling.firstElementChild.innerHTML = (++likecount);
                }
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    viewArticle(stageId, articleId, articleUrl, viewc, likec, artNm, e) {
        let postData = {
            "articleId": articleId,
            "actionStatus": "1",
            "stageId": stageId,
            "moduleType": "momdietplan"
        }
        var url = global.api_ci_url + "DietplanMom/getViewAction";
        // var url = global.api_url + "momdiet/savearticleviewaction";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.changeData(articleId,'viewAction',1,articleUrl);
                // window.location.href = articleUrl;
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);  
    }
    changeData(id, type, status,articleUrl) {
        let articlesData = this.state.articlesData;
        let initialData =  this.state.initialData;
        articlesData && articlesData.forEach((articles) => {
            if (articles.articleId == id) {
                if (type == "viewAction") {
                    if (parseInt(status) == 1) {
                        // console.log("successss====>",articles.articleId);
                        articles.viewCount = parseInt(articles.viewCount) + 1;
                    } else if (parseInt(status) == 0) {
                        // articles.viewCount = parseInt(video.bookmarkCount) - 1;
                    }
                }
            }
        });
        initialData['result']=articlesData;
        // this.setState({ articlesData: articlesData });
        // this.setState({ initialData: initialData });
        this.setState({ articlesData: articlesData ,initialData:initialData},()=>{
            if(type=="viewAction"){
                window.location.href = articleUrl;
            }
        });
    }
    // lastCall(){
    //     console.log("last Call");
    //     let id = this.state.currentstage;

    //         let left = parseInt(id) + 5;
    //         let cards_offset = 0;
    //         if (document.querySelector('#month-card-' + left) && document.querySelector('#month-card-' + left).offsetTop) {
    //             cards_offset = document.querySelector('#month-card-' + left).offsetTop;
    //         }
    //             setTimeout(() => {
    //                 if(document.querySelector('.left.active').id.split("-")[1]!=currentWeek){
    //                        this.weekclick('',currentWeek);
    //                     // this.getDietplanBabyData(3861841);
    //                     // document.querySelector('html,body').scrollTop = cards_offset-70;
    //                 }
    //             }, 1000);
    //         }
    // }
    render() {
        return (
            <main className="main-container pregnancy_diet">
                <Helmet
                    title="Diet Plan for Pregnant Women - Foods to Eat and Avoid"
                    meta={[
                        { "name": "description", "content": "Eating well while pregnant is important, If you are checking for what foods to eat for a healthy pregnancy then follow our month by month pregnancy diet plan for a healthy baby." },
                        { "name": "keywords", "content": "diet for pregnant women, food for pregnant women, pregnancy diet" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Pregnancy Diet Plan  - Month by Month</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Diet Plan - Month by Month</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="dietplan-block">
                            <div className="diet_top momDiet">
                                {!global.ftk ?
                                    (<div className="drop-down">
                                        <div className="selected-child">
                                            <div className="M24_pink">
                                                <div className="diet-title">Diet Plan Chart
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    ) :
                                    <div className="drop-down">
                                        <div className="selected-child">
                                            <div className="M24_pink">
                                                <div className="diet-title">
                                                    <span className="diet-text">Diet Plan for </span>  
                                                               <span className="childname">{global.userAry['userName']}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <input type="hidden" id="currentStageId" name="currentStageId" value={this.state.currentStageId} />
                                <DietPlanSlider eleRef={this} Slidedata={this.state.stageResponse} tool={'md'}/>
                            </div>
                            <DietPlanArticle eleRef={this} Articledata={this.state.articlesData} tool={'md'}/>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )

    }
}

export default withContext(DietplanMom);
